import { createContext, useContext, useState, useRef } from 'react'

import { useDisclosure } from '@mantine/hooks'

import { navigate } from '@redwoodjs/router'

const TaskModalContext = createContext(null)

const TaskModalContextProvider = ({ children }) => {
  const [opened, { open, close }] = useDisclosure(false)
  const [taskId, setTaskId] = useState(null)
  const [applicant, setApplicant] = useState(null)
  const refetchRef = useRef(null)

  // Registration function for refetch
  const registerRefetch = (fn) => {
    refetchRef.current = fn
  }

  // Call this to trigger the registered refetch
  const callRefetch = () => {
    if (typeof refetchRef.current === 'function') {
      refetchRef.current()
    }
  }

  const handleOpen = ({ id = null, applicant = null } = {}) => {
    setApplicant(applicant)
    setTaskId(id)
    open()
  }

  const handleClose = () => {
    //Remove id from url if on task page
    if (window.location.pathname.includes('/tasks/')) {
      navigate(`/tasks`)
    } else if (window.location.pathname.includes('/applicants/')) {
      // Remove ?taskId from applicant details URLs
      const params = new URLSearchParams(window.location.search)
      if (params.has('taskId')) {
        params.delete('taskId')
        const next = `${window.location.pathname}${
          params.toString() ? `?${params.toString()}` : ''
        }`
        navigate(next, { replace: true })
      }
    }
    setTaskId(null)
    setApplicant(null)
    close()
  }

  return (
    <TaskModalContext.Provider
      value={{
        opened,
        handleClose,
        handleOpen,
        taskId,
        applicant,
        registerRefetch, // expose registration
        callRefetch, // expose trigger
      }}
    >
      {children}
    </TaskModalContext.Provider>
  )
}

export function useTaskModalContext() {
  return useContext(TaskModalContext)
}

export { TaskModalContext, TaskModalContextProvider }
